import { SET_AUTH_STATUS, LoginActionTypes, LoginState} from './types';

export function authorizeAccount(status: LoginState): LoginActionTypes {
    return {
      type: SET_AUTH_STATUS,
      payload: status
    }
  }